module.exports = __webpack_public_path__ + "Icono_EscanearCodigoQR_126px.png";